import { AuthService } from './../../../../shared/services/auth.service';
import { IAccount } from './../../../../_models/account/user';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html'
})
export class ProfileFormComponent implements OnInit {
  title: string = 'Edit Profile';
  loading: boolean;
  profile: IAccount;
  profileForm: FormGroup;
  id;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: AuthService,
    private toastrService: ToastrService,
    private fb: FormBuilder) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.createProfileForm();
    this.getProfile();
  }

  private getProfile() {
    if (this.id)
      this.service.get(this.id).subscribe((response: any) => {
        if (response) {
          this.profile = response;
          this.title = 'Edit Profile for ' + response.email;
          this.setValueProfileForm();
        }
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
  }

  submit() {
    if (this.profileForm.valid) {
      this.loading = true;
      this.profile = Object.assign({}, this.profileForm.getRawValue());
      this.service.editProfile(this.profile).subscribe((response: any) => {
        if (response) {
          this.toastrService.success("Saved successfully.");
          this.router.navigate(['/admin/users']);
        }
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false
      );
    }
  }

  createProfileForm() {

    this.profileForm = this.fb.group({
      id: ['', Validators.required],
      shalaId: ['', [Validators.required, Validators.pattern(/^([0-9]{10})([0-9]){0,1}$/)]],
      phoneNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      emailConfirmed: [false],
    });

    if (this.profile) {
      this.setValueProfileForm();
    }
  }

  setValueProfileForm() {
    this.profileForm.patchValue({
      id: this.profile.id,
      shalaId: this.profile.shalaId,
      phoneNumber: this.profile.phoneNumber,
      email: this.profile.email,
      emailConfirmed:this.profile.emailConfirmed,
    });
  }

}
